module.exports = require('react-error-boundary')
